var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "p-5 font-size-30"
  }, [_c('div', {
    staticClass: "font-weight-bold mb-3"
  }, [_vm._v("Unauthorized")]), _c('div', [_vm._v("You don't have required priviledge to access this page.")]), _c('div', {
    staticClass: "font-weight-bold font-size-70 mb-1"
  }, [_vm._v("403 —")]), _c('router-link', {
    staticClass: "btn btn-outline-primary width-100",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Go Back")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }